const root = `${process.env.VUE_APP_HOST}patient`;
const edm = `${process.env.VUE_APP_EDM_HOST}`;

export const ExternalLinks = {
  MYDR_LOGIN: `${root}`,
  MYDR_REGISTER: `${root}/register`,
  MYDR_NEW_VISIT: (type: 'evisit' | 'stationary') => `${root}/new-visit/${type}`,
  MYDR_EDM: edm,
  MYDR_EDM_LOGIN: `${edm}/secure`,
  MYDR_INCIDENT_INFO: 'https://pro.mydr.pl/portal-info',
  MYDR_PATIENT_INCIDENT_INFO: 'https://pacjent.mydr.pl/',
} as const;
